import React, { useEffect } from "react";

import { useAddSourceCustom } from "@/api/knowledge-source/add-source-custom";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

import KnowledgeSourceButtons from "../knowledge-source-buttons/knowledge-source-buttons";
import useGlobalPermission from "@/store/user-permissions";

const CustomTextSource = () => {
    const [header, setHeader] = React.useState("");
    const [desc, setDesc] = React.useState("");

    const { mutate: addSource, isPending, isSuccess } = useAddSourceCustom();

    const handleAddSource = () => {
        addSource({ header, desc });
    };

    useEffect(() => {
        if (!isPending && isSuccess) {
            setDesc("");
            setHeader("");
        }
    }, [isSuccess, isPending]);
    const { permissionList } = useGlobalPermission();
    const trainingPermission = permissionList.find((item) => item.module.name === "AI_Training");
    return (
        <div>
            <h3 className="mb-2 font-bold">Name</h3>
            <Input
                className="mb-3 py-6"
                placeholder="Enter the Name of Your Data Source"
                onChange={(e) => setHeader(e.target.value)}
                value={header}
                disabled={!trainingPermission?.can_create}
            />
            <h3 className="mb-2 font-bold">Content</h3>
            <Textarea
                disabled={!trainingPermission?.can_create}
                className="mb-3 py-6"
                onChange={(e) => setDesc(e.target.value)}
                value={desc}
                placeholder="This text will be added to the knowledge of your Chatbot. Carefully add relevant content."
            />

            <KnowledgeSourceButtons onSubmit={handleAddSource} loading={isPending} />
        </div>
    );
};

export default CustomTextSource;
